import StateObserver from 'src/StateObserver';
import PopupCheats, { Item } from 'src/game/cheats/PopupCheats';
import { CheatData } from 'src/game/cheats/cheats.sequences';
import { closeAllPopups } from 'src/lib/popups/popupOpenClose';
import LangBitmapFontTextView from 'src/lib/ui/components/LangBitmapFontTextView';

const MATCH2_BUNDLE_SALE = 'match2 Bundle Sale';

const list = () => {
  const cheats: Record<string, CheatData[]> = {};

  cheats[MATCH2_BUNDLE_SALE] = [
    {
      text: 'Reset Bundle Sale',
      color: 'secondary',
      cheat: async () => {
        await StateObserver.invoke.cheat_bundleSaleReset();
        closeAllPopups();
      },
    },
    {
      text: 'Purchase Next 5',
      color: 'secondary',
      cheat: async () => {
        await StateObserver.invoke.cheat_bundlePurchaseNextItems(5);
        closeAllPopups();
      },
    },
    {
      text: 'Purchase Next 45',
      color: 'secondary',
      cheat: async () => {
        await StateObserver.invoke.cheat_bundlePurchaseNextItems(45);
        closeAllPopups();
      },
    },
    {
      text: 'Purchase All',
      color: 'secondary',
      cheat: async () => {
        await StateObserver.invoke.cheat_bundlePurchaseNextItems(999);
        closeAllPopups();
      },
    },
  ];

  return cheats;
};

const ui = (args: {
  key: string;
  popup: PopupCheats;
  item: Item;
  title: LangBitmapFontTextView;
  setting: CheatData[];
  parent: Item | null;
}) => {
  switch (args.key) {
    case MATCH2_BUNDLE_SALE:
      args.title.updateOpts({
        width: args.item.style.width - 40,
        height: 20,
        y: 8,
        align: 'center',
      });
      args.popup.createVerticalButtons(args.item, args.setting);
      break;
  }
};

export const match2BundleSaleCheats = {
  list,
  ui,
};
